import { factory as ulidFactory, ulid } from 'ulid';

/**
 * Entity identifiers are ULIDs generated by the caller, not the database.
 *
 * Two reasons. A record can be created on a phone with no signal and keep the
 * same identity once it syncs, and swapping the database later never changes
 * the shape of an id that may already be in a printed document or a URL.
 * ULIDs also sort by creation time as plain strings, so lists come back in a
 * sensible order without a separate sequence column.
 */
export type Id = string & { readonly __brand?: 'Id' };

const ULID_PATTERN = /^[0-9A-HJKMNP-TV-Z]{26}$/;

export function newId(): Id {
  return ulid();
}

export function isId(value: unknown): value is Id {
  return typeof value === 'string' && ULID_PATTERN.test(value);
}

/** Deterministic generator for tests that need reproducible, ordered ids. */
export function newIdFactory(random: () => number): (seedTime?: number) => Id {
  const generate = ulidFactory(random);
  return (seedTime?: number) => generate(seedTime);
}
